import { createCustomElement } from '@angular/elements';
import { PershingComponentStrategyFactory } from './pershing-custom-elements-factory';

export function createCustomElementWrapper(customElementSelector, componentType, config) {
  config.strategyFactory = new PershingComponentStrategyFactory(componentType, config);
  const element = createCustomElement(componentType, config);
  customElements.define(customElementSelector, element);
}
